import * as Yup from 'yup'
/* eslint-disable import/prefer-default-export */
export const schema = Yup.object().shape({
  receptionDate: Yup.string().required('La fecha de recepción es requerida'),
  reason: Yup.string().required('El motivo es requerido'),
  descriptions: Yup.string().required('La Argumentación es requerida'),
  documentsNames: Yup.array()
})
